import { writable } from 'svelte/store';
const PORT_STATE = Object.freeze({
    DISCONNECTED_NO_REF: {
        // NOT USED
        text: "Disconnected",
        color: "grey",
    },
    DISCONNECTED_REF: {
        text: "Disconnected",
        color: "red",
    },
    CONNECTED_NOT_ACT: {
        text: "Inactive",
        color: "yellow",
    },
    CONNECTED_ACT: {
        text: "Active",
        color: "green",
    },
});
function generateRoutinchInfo() {
    const fullWritable = writable([]);
    const partialWritable = writable(null);
    const mapWritable = writable({});
    let map = {};
    let userToken = null;
    function pushnewFull() {
        fullWritable.set(Object.keys(map).map(key => map[key]));
        mapWritable.set(map);
    }
    return {
        subscribeUpdate: partialWritable.subscribe,
        subscribeNew: fullWritable.subscribe,
        subscribeMap: mapWritable.subscribe,
        setAll: (newList) => {
            map = {};
            newList.forEach(route => {
                map[route.id] = route;
            });
            pushnewFull();
        },
        setSwitch: (route) => {
            if (route.id in map) {
                delete map[route.id];
            }
            else {
                map[route.id] = route;
            }
            partialWritable.set(route);
            pushnewFull();
        },
        /*  setRm:  (route: RoutingInfo) => {
             delete map[route.id];
             partialWritable.set(route);
             pushnewFull();
         }, */
    };
}
export const RoutinchInfo = generateRoutinchInfo();
function generateNewUserCredentials() {
    const { subscribe, set } = writable(null);
    let lastToken = null;
    let lastUserInfo = null;
    return {
        /* subscribe: (subsscription) => {

            subscribe(subsscription)
        }, */
        subscribe: subscribe,
        connect: (userInfo, token) => {
            lastToken = token;
            lastUserInfo = userInfo;
            pushUserChangesToStaticComponents(token); // HERE ?
            set(userInfo);
        },
        disconect: () => {
            lastToken = null;
            lastUserInfo = null;
            set(null);
        },
        getToken: () => {
            return lastToken;
        },
        getUserInfo: () => {
            return lastUserInfo;
        }
    };
}
export const UserCredential = generateNewUserCredentials();
function generatePrinterPort() {
    const { subscribe, set } = writable(null);
    return {
        /* subscribe: (subsscription) => {

            subscribe(subsscription)
        }, */
        subscribe: subscribe,
        connect: (dev) => {
            // curentVal = dev;
            set(dev);
        },
        disconect: () => {
            // curentVal = null;
            set(null);
        },
    };
}
export const Pinter = generatePrinterPort();
export function generateBinChannel() {
    const { subscribe, set } = writable(null);
    let enable = true;
    return {
        subscribe: subscribe,
        disable: () => enable = false,
        enable: () => enable = true,
        send: (data) => {
            if (enable) {
                set(data);
            }
            else {
                throw new Error('Connection closed');
            }
        },
    };
}
function generateNewSPort() {
    const { subscribe, set } = writable(null);
    let curentVal = null;
    return {
        /* subscribe: (subsscription) => {

            subscribe(subsscription)
        }, */
        subscribe: subscribe,
        connect: (port) => {
            curentVal = port;
            set(port);
        },
        disconect: () => {
            curentVal = null;
            set(null);
        },
        getCurent: () => {
            return curentVal;
        }
    };
}
export const SPort = generateNewSPort();
function pushUserChangesToStaticComponents(userToken) {
    // setToken(userToken); // TOOD
    // reloadGlobalData();
}
function initWikaMock() {
    const ENC = new TextEncoder();
    const DEC = new TextDecoder();
    const portHandle = {
        meta: {
            name: 'Test port',
            state: PORT_STATE.CONNECTED_ACT,
        },
        writerObs: generateBinChannel(),
        readerObs: generateBinChannel(),
    };
    let lastVal = 0;
    portHandle.writerObs.subscribe(bin => {
        if (!bin)
            return;
        const val = DEC.decode(bin);
        lastVal = +Math.round(Math.random() * 2000) / 1000 - 1;
        if (val === 'measure:channel? 1\r\n') {
            portHandle.readerObs.send(ENC.encode(`1,${lastVal},"CEL"\r\n`));
        }
        else if (val === 'measure:channel? 2\r\n') {
            portHandle.readerObs.send(ENC.encode(`2,${lastVal},"CEL"\r\n`));
        }
        else {
            portHandle.readerObs.send(ENC.encode('WIKA,CTH7000,000000,V1.1,02/02/2017\r\n'));
        }
    });
    SPort.connect(portHandle);
}
window.DEV_wika = initWikaMock;
// DEV
/* Pinter.connect({
    ref: null,
    name: "test virtual device",
    send: (val) => {
        console.log('Printed:', val)
    }
}) */
